import getData from "@/commonJS/getData";

export function getLinkWithLocale(
  href: string,
  locale: string,
  field: any
): string {
  if (
    (field?.defaultLocale ?? true) &&
    !href?.includes("http") &&
    field?.target !== "_blank" &&
    locale &&
    locale !== "en"
  ) {
    return `/${locale}${href}`;
  }
  return href;
}

export function getDynamicParamsHref(
  field: any,
  globalState: any,
  fullGlobalState: any,
  store: any,
  layoutStore: any
) {
  let constructedUrl = "";
  const dynamicValues: Record<string, string> = {};

  field?.href?.split("/")?.forEach((urlPart: string) => {
    if (urlPart?.startsWith("[") && urlPart?.endsWith("]")) {
      const key = urlPart.slice(1, -1);
      const mapping = field?.dyanmicUrlMapping?.[key];
      const source =
        mapping?.source === "GLOBAL"
          ? globalState
          : mapping?.source === "REDUX"
          ? { page: store, layout: layoutStore }
          : fullGlobalState;

      dynamicValues[key] = getData(
        mapping,
        source,
        globalState,
        fullGlobalState,
        { page: store, layout: layoutStore }
      );
    }
  });

  constructedUrl = field?.href?.replace(
    /\[(\w+)\]/g,
    (_: any, key: string) => dynamicValues[key] ?? ""
  );

  if (constructedUrl?.includes("?")) {
    constructedUrl = constructedUrl.split("?")[0];
  }

  if (field?.queryParams) {
    constructedUrl += "?";
    const keys = Object.keys(field.queryParams);
    keys.forEach((key, index) => {
      const value =
        typeof field.queryParams[key] === "object"
          ? getData(
              field.queryParams[key],
              field.queryParams[key]?.source === "GLOBAL"
                ? fullGlobalState
                : field.queryParams[key]?.source === "REDUX"
                ? { page: store, layout: layoutStore }
                : globalState
            )
          : field.queryParams[key];

      constructedUrl += `${key}=${value}${index < keys.length - 1 ? "&" : ""}`;
    });
  }

  return constructedUrl;
}
